import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export type UrgencyStatistic = {
  date: string;
  emergency: number;
  needs_attention: number;
  routine: number;
  informational: number;
};

// eslint-disable-next-line import/prefer-default-export
export function useUrgencyStatistics(queryParams: string) {
  return useQuery<UrgencyStatistic[]>({
    queryKey: [APIKey.URGENCY_STATISTICS, queryParams],
    queryFn: () =>
      baseFetcher(`${apiRoutes.urgencyStatistics()}?${queryParams}`),
  });
}
